import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  scrollContainer: {
    height: 'calc(100vh - 64px)',
    overflow: 'auto',
  },
  delete: {
    padding: theme.spacing(1),
    margin: theme.spacing(0.7),
    stroke: theme.palette.grey[600],
    '&:hover': {
      stroke: theme.palette.grey[800],
    },
  },
  deleteIcon: {
    padding: 0,
    paddingLeft: 10,
    stroke: theme.palette.grey[600],
    '&:hover': {
      stroke: theme.palette.grey[800],
    },
  },
}));

export default useStyles;
